'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'candle-holder';
var width = 512;
var height = 512;
var aliases = [128367];
var unicode = 'f6bc';
var svgPathData = 'M192 112c0-3.2 3.6-14.8 17.4-33.6 4.7-6.4 9.8-12.5 14.6-18.1 4.9 5.5 9.9 11.7 14.6 18.1 13.8 18.7 17.4 30.4 17.4 33.6 0 17.7-14.3 32-32 32s-32-14.3-32-32zm32 80c44.2 0 80-35.8 80-80 0-39.6-49.1-90.1-66.2-106.6-3.7-3.6-8.7-5.4-13.8-5.4s-10.1 1.9-13.8 5.4c-17.1 16.4-66.2 67-66.2 106.6 0 44.2 35.8 80 80 80zM440 416c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0-24c0-13.3 10.7-24 24-24zm-48 96l48 0c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72l0 24-32 0 0-176c0-26.5-21.5-48-48-48l-128 0c-26.5 0-48 21.5-48 48l0 176-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0zM160 464l0-176 128 0 0 176-128 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCandleHolder = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;